// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eLQ4","title":"styles_title__2OZro"};